/**
 * Menu Search Service
 * RAG 기반 메뉴 검색 API 클라이언트
 */

import api from './api';
import type { MenuSearchResponse, MenuSuggestResponse } from '@/types/menuSearch';

export const menuSearchService = {
  /**
   * 메뉴 통합 검색
   */
  async search(
    query: string,
    options?: {
      limit?: number;
      semanticWeight?: number;
      keywordWeight?: number;
    }
  ): Promise<MenuSearchResponse> {
    const params = new URLSearchParams({
      q: query,
      limit: options?.limit?.toString() || '10',
      ...(options?.semanticWeight && { semantic_weight: options.semanticWeight.toString() }),
      ...(options?.keywordWeight && { keyword_weight: options.keywordWeight.toString() }),
    });

    const response = await api.get<MenuSearchResponse>(`/menus/search?${params}`);
    return response.data;
  },

  /**
   * 자동완성 제안
   */
  async suggest(query: string, limit = 5): Promise<MenuSuggestResponse> {
    const params = new URLSearchParams({
      q: query,
      limit: limit.toString(),
    });

    const response = await api.get<MenuSuggestResponse>(`/menus/suggest?${params}`);
    return response.data;
  },

  /**
   * 클릭 로그 기록
   */
  async logClick(menuId: number, searchQuery: string): Promise<void> {
    await api.post(`/menus/search/${menuId}/click`, null, {
      params: { search_query: searchQuery },
    });
  },
};
